import React from "react";
import { BooleanCell } from "@/react/components/table/components/cells";
import styled from "styled-components";
import DateCell from "@/react/features/globalization/DateCell";
import { COLORS, SEMI_BOLD_FONT_WEIGHT } from "@/react/theme/constants";
import { color } from "@8x8/oxygen-constants";

const PrintNeverSpan = styled.span`
  @media print {
    display: none !important;
  }
`;

const PrintOnlySpan = styled.span`
  display: none;
  @media print {
    display: block;
  }
`;

const ReadableCellWrapper = styled.span`
  font-weight: ${SEMI_BOLD_FONT_WEIGHT};
  color: ${({ value }) => (value ? color.jadeGreen : color.coral)};
`;

const EditorTextContainer = styled.div`
  color: ${COLORS.primary};
  white-space: normal;
  p {
    margin: 0;
  }
  a {
    color: ${COLORS.link};
    text-decoration: underline;
  }
`;

const PseudoCellRenderContainer = styled.span`
  display: flex;
  gap: 16px;
`;

export const ReadableCell = (props) => {
  return (
    <ReadableCellWrapper value={props.value}>
      {props.value ? "YES" : "NO"}
    </ReadableCellWrapper>
  );
};
export const BooleanCellPrintReadable = (props) => {
  return (
    <>
      <PrintNeverSpan>
        <BooleanCell getValue={() => props.value} />
      </PrintNeverSpan>
      <PrintOnlySpan>
        <ReadableCell value={props.value} />
      </PrintOnlySpan>
    </>
  );
};

export const PseudoHeader = styled.div`
  letter-spacing: ${({ theme }) => theme.tableCellHeadLetterSpacing};
  font-weight: ${({ theme }) => theme.tableCellHeadFontWeight};
  font-size: ${({ theme }) => theme.tableCellHeadFontSize};
  line-height: ${({ theme }) => theme.tableCellHeadLineHeight};
  font-family: ${({ theme }) => theme.tableCellHeadFontFamily};
  color: ${({ theme }) => theme.tableCellHeadColor};
  background-color: ${({ theme }) => theme.tableCellHeadBackgroundColor};
`;

export const PseudoCellRender = (props) => {
  return (
    <PseudoCellRenderContainer>
      <PseudoHeader>{props.header}:</PseudoHeader>
      {props.value}
    </PseudoCellRenderContainer>
  );
};

export const EditorText = ({ children }) => {
  return (
    <EditorTextContainer
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  );
};

export const LastUpdateFromList = ({ title, list }) => {
  const latestObject = list.reduce((latest, current) => {
    if (!latest || current.last_update > latest.last_update) {
      return current;
    }
    return latest;
  }, null);

  const latestValue = latestObject ? latestObject.last_update : undefined;
  return (
    <PseudoCellRender
      header={title}
      value={!latestObject ? "N/A" : <DateCell value={latestValue} />}
    />
  );
};
